import { Injectable } from '@angular/core';
import { TransferHttpService } from '../../services/transfer-http/transfer-http.service';
import { HttpClient } from '@angular/common/http'
import { Observable, Subject } from 'rxjs'
import { switchMap, tap } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class MainGridService<T> {

  private data = new Subject<T[]>()
  private _data
  private getUrl
  private saveUrl
  private deleteUrl

  constructor(private transferHttp: TransferHttpService) {}

  private setup(getUrl: string, saveUrl: string, deleteUrl: string) {
    this.getUrl = getUrl;
    this.saveUrl = saveUrl;
    this.deleteUrl = deleteUrl;
  }

  getAll(getUrl?: string, saveUrl?: string, deleteUrl?: string): Observable<T[]> {
    this.setup(getUrl, saveUrl, deleteUrl);
    this.transferHttp.getHot<T[]>(this.getUrl).subscribe((result) => {
      this.data.next(result)
      this._data = result
    })
    return this.data.asObservable()
  }

  /*
    Update this element, then update the grid
    Reminder - the component needs to subscribe
    e.g. this.mainGridService.update(update.newRow, update.index).subscribe(update.handleSubscribe())
  */
  update(element: T, idx: number): Observable<T> {
    return this.transferHttp.put(this.saveUrl, element).pipe(
      tap((x) => {
        this._data[idx] = element
        this.data.next([...this._data])
      })
    )
  }

  /**
   * This allows to pass in the old and new object and the index is found by using the old object.
   * Useful for tables that act on filtered data so the correct index isn't known.
   */
  updateByObject(element: T, elementOld: T): Observable<T> {
    const idx = this._data.findIndex(item => item === elementOld)
    return this.update(element, idx)
  }
  /*
    Delete the element by passing in the columnName and id to delete, then remove it from the table
    Reminder - the component needs to subscribe
    e.g.
    const row = deleted.row as FacEquipmentMeters;
    this.mainGridService.delete(row.manufacturerId, 'manufacturerId', deleted.index).subscribe(deleted.handleSubscribe());
  */
  delete(id:number|string, idColumnName:string, idx: number): Observable<T> {
    const url = this.deleteUrl + '?' + idColumnName + '=' + id
    return this.transferHttp.delete(url).pipe(
      tap((x) => {
        this._data.splice(idx, 1)
        this.data.next([...this._data])
      })
    )
  }

  /*
    Add the element at the saveUrl
    Reminder - the component needs to subscribe
    e.g. this.mainGridService.add(update.newRow).subscribe(update.handleSubscribe())
  */
  add(element: T): Observable<T> {
    // Surprised the main-grid used a PUT for the add.
    return this.transferHttp.put(this.saveUrl, element).pipe(
      tap((x) => {
        this._data.unshift(x.savedEntity)
        this.data.next([...this._data])
      })
    )
  }

  ngOnDestroy() {
    this.data.next(null)
    this.data.complete()
  }

}

